import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { PauseRecurringPushNotificationUseCaseInterface } from 'domain/usecases';

export class RemotePauseRecurringPushNotification
  implements PauseRecurringPushNotificationUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: PauseRecurringPushNotificationUseCaseInterface.Params,
  ): Promise<PauseRecurringPushNotificationUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: this.url + `/${params.id}`,
      method: 'patch',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
